import React, { Component, createRef } from 'react';
import Parser from 'html-react-parser';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';
import { ChevronLeftIcon, ChevronRightIcon, ArrowIcon } from './SVGIcons';

// Импорт стилей Swiper
import 'swiper/css';
import 'swiper/css/navigation';

class First extends Component {
  static defaultProps = {
    more: 1
  }

  state = {
    isBeginning: true,
    isEnd: false
  }

  constructor(props) {
    super(props);
    this.swiperRef = createRef();
  }

  handleSlideChange = (swiper) => {
    this.setState({
      isBeginning: swiper.isBeginning,
      isEnd: swiper.isEnd
    });
  }

  render() {
    const { isBeginning, isEnd } = this.state
    const { more } = this.props

    const data = this.props?.data || {}
    const stati = data?.stati || {}
    const items = stati?.items || []

    return (
      <div className={more == 1 ? `mt-[80px] xl:mt-[100px]` : `mt-[40px]`}>
        <div className='container'>
          <div className='text-title text-ptblack uppercase tracking-tight'>{Parser(stati?.title || '')}</div>
          <div className='flex items-center justify-between gap-[20px] mt-[12px]'>
            <div className='text-base text-ptgray max-w-[672px] leading-none'>
              {Parser(stati?.text || '')}
            </div>
            <div className='flex items-center gap-[10px]'>
              {/* Левая кнопка навигации */}
              <div 
                className={`w-[38px] h-[38px] rounded-[14px] flex items-center justify-center bg-[#F6F7F8] text-[#141414] cursor-pointer transition-opacity duration-300 ${
                  isBeginning ? 'opacity-30 cursor-not-allowed' : 'opacity-100 hover:bg-[#E8E9EA]'
                }`}
                onClick={() => !isBeginning && this.swiperRef.current?.slidePrev()}
              >
                <ChevronLeftIcon width={6} height={12} stroke="currentColor" />
              </div>
              {/* Правая кнопка навигации */}
              <div 
                className={`w-[38px] h-[38px] rounded-[14px] flex items-center justify-center bg-[#F6F7F8] text-[#141414] cursor-pointer transition-opacity duration-300 ${
                  isEnd ? 'opacity-30 cursor-not-allowed' : 'opacity-100 hover:bg-[#E8E9EA]'
                }`}
                onClick={() => !isEnd && this.swiperRef.current?.slideNext()}
              >
                <ChevronRightIcon width={6} height={12} stroke="currentColor" />
              </div>
            </div>
          </div>
          
          {/* Слайдер Swiper */}
          <div className='mt-[40px]'>
            <Swiper
              onSwiper={(swiper) => {
                this.swiperRef.current = swiper;
                this.handleSlideChange(swiper);
              }}
              onSlideChange={this.handleSlideChange}
              modules={[Navigation]}
              spaceBetween={21}
              slidesPerView={3}
              breakpoints={{
                0: {
                  slidesPerView: 1,
                  spaceBetween: 16
                },
                640: {
                  slidesPerView: 2,
                  spaceBetween: 20
                },
                1024: {
                  slidesPerView: 3,
                  spaceBetween: 21
                }
              }}
            >
              {items.map((el, index) => (
                <SwiperSlide key={index}>
                  <div className='bg-cover bg-center rounded-[14px] overflow-hidden' style={{ backgroundImage: `url('${el.image}')` }}>
                    <div className='w-full min-h-[215px] p-[20px] bg-gradient-to-t from-[#00135133]/20 to-[#00071E] flex flex-col justify-between items-start'>
                      <div className='text-cardTitle text-white uppercase leading-none font-light max-w-[255px]'>{el.title}</div>
                      <div className='w-full flex items-end justify-between'>
                        <div className='text-base text-white/70'>{el.data}</div>
                        <a href={el.href} className='cursor-pointer bg-white duration-300 ease-in-out hover:bg-[#DBE7F3] px-[22px] h-[38px] flex-none flex items-center justify-center rounded-[14px] gap-[12px] text-ptblack'>
                          <div className='text-base'>Читать статью</div>
                          <ArrowIcon width={16} height={16} stroke="currentColor" />
                        </a>
                      </div>
                    </div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
          
          {more == 1 &&
            <div className='mt-[20px] w-full flex justify-start'>
              <a 
                href={data?.links?.materiali} 
                className='w-full xl:w-auto flex items-center justify-center gap-[8px] px-[8px] bg-[#F6F7F8] rounded-[14px] h-[48px] mt-[25px] transition-colors duration-300 hover:bg-[#141414] group text-[#141414] hover:text-white'
              >
                <div className='text-base transition-colors duration-300 group-hover:text-white'>Все материалы</div>
                <ArrowIcon width={16} height={16} stroke="currentColor" />
              </a>
            </div>
          }
        </div>
      </div>
    )
  }
}

export default First;